// extracted by mini-css-extract-plugin
export var container = "_5c-0";
export var error = "_5c-9";
export var label = "_5c-5";
export var light = "_5c-6";
export var md = "_5c-3";
export var sm = "_5c-2";
export var thin = "_5c-8";
export var thinBold = "_5c-7";
export var vertical = "_5c-4";
export var xs = "_5c-1";